import { logger } from './logger';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const medusaError = (error: any) => {
  if (error?.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const u = new URL(error?.config.url, error?.config.baseURL);
    logger.error('Resource:', u.toString());
    logger.error('Response data:', error?.response.data);
    logger.error('Status code:', error?.response.status);
    logger.error('Headers:', error?.response.headers);

    // Extracting the error message from the response data
    const message = error.response?.data?.message || error.response?.data;
    throw new Error(`Medusa: ${message}`);
  } else if (error?.request) {
    // The request was made but no response was received
    throw new Error('No response received: ' + error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    throw new Error('Error setting up the request: ' + error?.message);
  }
};
